// import nextArr from '../../assets/ALeft.png'
import nextArr from '../../assets/icon/nextL.png'
import prevArr from '../../assets/icon/next.png'

import nextArr1 from '../../assets/icon/Larrow.png'
import prevArr1 from '../../assets/icon/Rarrow.png'

// import warning from '../../assets/icon/warning.svg'

import { fabrics, StylesFilter, StylesFilter_Blazer, StylesFilter_formal, StylesFilter_kurta, StylesFilterMob_Blazer } from '../../Data';
import dummy from '../../assets/samples/body.png'
// import { dummyImg } from '../../Data'

import F from '../../assets/icon/F.svg'
import I from '../../assets/icon/info.png'
import emb_logo_mob from '../../assets/icon/emb_logo_mob.png'
import S from '../../assets/icon/S.svg'

import logo_m from '../../assets/download.svg'
import default_shirt from '../../assets/samples/shirt/SHIRT.png'
// import shirt from '../../assets/samples/shirt/grey_shirt.png'
// import coat from '../../assets/samples/coat/red_coat.png'
// import jacket from '../../assets/samples/jacket/red_jacket.png'
// import pant from '../../assets/samples/pant/red_pant.png'

// import blue_coat from '../../assets/samples/coat/blue_coat.png'
// import blue_coat1 from '../../assets/samples/coat/blue_coat1.png'
// import s_coat from '../../assets/samples/coat/3BFP.png'

// import blue_back from '../../assets/samples/coat/0VBCOLO35.png'
// import s_back from '../../assets/samples/coat/0VBSPH75.png'

// import b_single from '../../assets/samples/coat/1BFNCOLO35.png'
// import s_single from '../../assets/samples/coat/1BFNSPH75.png'

// import v_b_single from '../../assets/samples/coat/DBVESTCOLO35.png'
// import v_s_single from '../../assets/samples/coat/VESTSPH75.png'

// import b_vest from '../../assets/samples/jacket/JACKET.png'
// import s_vest from '../../assets/samples/jacket/JACKET1.png'

// import b_pant from '../../assets/samples/pant/PANT.png'
// import s_pant from '../../assets/samples/pant/PANT1.png'

// import shirt from '../../assets/samples/shirt/SHIRT BODY.png'
// import color from '../../assets/samples/shirt/SPR.png'

// import s1 from '../../assets/samples/shirt/z/B COLLOR.png'
// import s2 from '../../assets/samples/shirt/z/BASE.png'
// import s3 from '../../assets/samples/shirt/z/CUFFLINK.png'
// import s4 from '../../assets/samples/shirt/z/SLEEV.png'
// import s5 from '../../assets/samples/shirt/z/pocket palla.png'
import close from '../../assets/icon/close.png'
import raymond from '../../assets/icon/Raymond.svg'

import curl from '../../assets/Arrow/curl.png'
import { useEffect, useRef, useState } from 'react'
import { getDatafromDoc } from '../../Firebase/firestoreGet'
import { db } from '../../firebase'
import {Types} from '../../Data'
import info from '../../assets/icon/info1.png'
import { useSwipeable } from 'react-swipeable';
import ViewImages from './viewImages'
import { useNavigate } from 'react-router-dom'
import { checkStyleConditions, encodeObj, isEmbEnabled } from '../../Functions';

import { Body_config } from '../../Data/index';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import M from '../../assets/icon/magnifying.svg'
import War from '../../assets/icon/w.svg'
import { Share_Like } from '../../common';
import { FileText, Share2, Heart, ZoomIn, User, Edit2 } from 'lucide-react';


export default function ViewFabric({category, sel, nav, setNav, setSel, loading,setLoading, state, setStates, single, setStylesAll, setMenuOpen,menuOpen,setMenuOpen2,menuOpen2, imgState, setImgState, jodh , mess, setMess, process, Navs, menuOpenEmb, setMenuOpenEmb, currBody, setCurrBody, getStyleImg}) {

    const navigate = useNavigate()

    // const [imgState, setImgState] = useState(0)
    
    const [fabricType, setType] = useState("")
    const [activeTool, setActiveTool] = useState(null);
    const [viewDet, setCurrentDet] = useState(
        category === "suit" ? "Coat" : category === "pant" ? "Pant" : category === "Shirt" ? "Shirt" : category === "kurta" ? "Kurta" 
        : category === "blazer" ? "Coat" : category === "sadri" ? "Sadri" :
        "Shirt"
    )
    const [viewD, setViewD] = useState()
    const [isMobile, setIsMobile] = useState(window.innerWidth < 480);
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedColor, setSelectedColor] = useState("");
    
    const [selectedFabric, setSelectedFabric] = useState(fabrics && fabrics.length > 0 ? fabrics[0] : null);
    
    const [styleDes, setStyleDes] = useState()

    const [initial, setInitial] = useState(true)

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };
    const selectFabric = (fabric) => {
        setSelectedFabric(fabric);
        setShowDropdown(false); // Close dropdown after selecting fabric
    };
    const handlers = useSwipeable({
        onSwipedLeft: () => {
            if (imgState <=
                 state - 1) {
                setLoading(true);
                setImgState(curr => curr + 1);
                setInitial(false)
            }
        },
        onSwipedRight: () => {
            if ( ( !(category ==="kurta" && (sel.types.includes("Coat") || sel.types.includes("Sadri") ) ) && imgState > 0) 
                || ( (category ==="kurta" && (sel.types.includes("Coat") || sel.types.includes("Sadri") ) ) &&  imgState > -1 ) ) {
                setLoading(true);
                setImgState(curr => curr - 1);
                setInitial(false)
            }
        }
    });
    const calPrice = (a)=>{  
        let p = 0
        Object.keys(a["fabric"]).forEach((element)=>{
            p+=Number(a["fabric"][element]["price"])
        }) 
        return p
    }
    

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 480);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    //handellling back button

    // function backMove () {
    //     if(nav === 1){
    //         setNav(0)
    //     }else {
    //         setNav(-1)
    //     }
        
    // }

    // useEffect(()=>{
    //     window.history.pushState( 'dummy', document.title, window.location.href )
    // }, [])

    // useEffect(()=>{
    //     if(nav === 1){window.history.pushState( 'dummy', document.title, window.location.href )

    //     window.addEventListener('popstate', backMove);
    //     console.log("someting")}

    //     return()=>{
    //         window.removeEventListener('popstate', backMove);

    //         if (window.history.state === 'dummy' && nav === 1) {
    //             window.history.back();
    //         }
        
    //     }

    // }, [])

    
    const getStyleDetails = ()=>{
        try{
            var StylesDets = {}
            const Stylesfilter_to_use = category === "kurta" ? StylesFilter_kurta
                                        : category === "blazer" ? StylesFilter_Blazer
                                        : category === "sadri" ? StylesFilter_kurta
                                        : category === "formal" || category === "shirt" || category === "pant" ? StylesFilter_formal
                                        : StylesFilter
            // console.log("coming here in Styles des funct")
            if(sel && sel.style){
                    
                Object.keys(sel["style"]).forEach((t)=>{
                    StylesDets[t] = []
                    Object.keys(sel["style"][t]).forEach((side)=>{
                        
                        var value = null;
                        var img = null;
                        sel["style"][t][side].forEach((val, k)=>{
                            if( (t!=="Shirt") 
                                || (t === "Shirt" && val!= "BASE" && val!="SLEVE")
                                
                            ){
                            
                            var r = null
                            
                            if(t === "Coat" && side === "F" && val[0] === "J"){
                                r = Stylesfilter_to_use.find((filter) => filter.type === "Jodhpuri");
                                console.log("r:", r)
                            } else{
                                r = Stylesfilter_to_use.find((filter) => filter.name === t && filter.pos === side && filter.n === k);
                            }
                            
                            if(!r){
                                return
                            }
                            // console.log(r, side, t)
                            if( checkStyleConditions(sel, r, jodh) ){
                                return
                            }
                            // console.log("from inside", r["attr"])
                            for(let i = 0;i<r["attr"].length;i++){
                                if(value){break}
                                if( Array.isArray(r["attr"][i])){
                                    for(let j = 0;j<r["attr"][i].length;j++){
                                        
                                        if(r["attr"][i][j]["value"] === val){
                                            value = r["attr"][i][j]["name"]
                                            img = r["attr"][i][j]["img"]
                                            break    
                                        }
                                    }
                                }else{
                                    if(r["attr"][i]["value"] === val){
                                        value = r["attr"][i]["name"]
                                        img = r["attr"][i]["img"]
                                        break
                                    }
                                }
                            }
                            
                            if(value){
                                StylesDets[t].push( {"type":r["type"], "name":value, "img":img})
                            }
                            
                            //  `${r["type"]} : ${value}`
                            value = null
                            }
                        })
                    })
                })

                setStyleDes(StylesDets)
                // console.log("From styles Description :", StylesDets)
                    
                // StylesFilter
            } 
        } catch(e){
            console.log(e)
        }
    }


    

    const DataCheck = ()=>{
        var Data = {...sel}
        var allow=  true;
        var c = 0;
        for(let i=0;i<Data["types"].length;i++){
            if(Data["fabric"] && !Data["fabric"][Data["types"][i]]){
                c = 1;
                if(i==0){
                    allow = false;
                    //Send an allert
                }else{
                    Data["farbic"][Data["types"][i]] = Data["farbic"][Data["types"][0]]
                }
                
            }
        }
        if(c === 1){setSel(Data)}
        return [Data, allow]
    }


    return(
        
        <div className="viewFabric" >

            {isMobile && (
                <a href="/" style={{textDecoration:"none"}}>
                <div className='Head'
                    onClick={()=>{
                        navigate("/")
                    }}
                >
                    <div className='logo_name'>
                        <img src={logo_m} style={{"width":"100%", "height":"100%", "objectFit":"contain"}}/>
                        
                    </div>
                    {/* <div
                        style={{"height":"70px", "width":"40px", "position":"relative"}}
                    ><label className='logo_name'>Maviinci</label></div> */}
                    
                </div>
                </a>
            )

            }
            

            <div className="viewBody" {...handlers}>
                
                {/* Edit Button - Top Left */}
                {/* <div className="top-edit-btn" style={{ left: '20px', right: 'auto', top: '20px', transform: 'none' }} onClick={() => {}}>
                    <Edit2 size={20} color="#000" />
                </div> */}

                <div className="bottom-right-icons" style={{
                    position: 'absolute',
                    bottom: '20px',
                    right: '20px',
                    display: 'flex',
                    gap: '20px',
                    zIndex: 100
                }}>
                    <div className="bottom-icon-container" style={{position: 'relative'}}>
                        {activeTool === 'skin' && (
                            <div className="body-type-popup" style={{
                                position: 'absolute',
                                bottom: '65px',
                                left: '0',
                                display: 'flex',
                                gap: '8px',
                                background: 'white',
                                padding: '8px',
                                borderRadius: '8px',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                whiteSpace: 'nowrap',
                                zIndex: 200,
                                transform: 'scale(0.9)',
                                transformOrigin: 'bottom left',
                                marginBottom: '10px' // Added padding from bottom
                            }}>
                                {/* Ensure exactly 5 options */}
                                {(() => {
                                    // Default placeholders if config is missing or empty
                                    const defaults = [
                                        {id:1, name:"Slim"}, 
                                        {id:2, name:"Regular"}, 
                                        {id:3, name:"Athletic"}, 
                                        {id:4, name:"Heavy"}, 
                                        {id:5, name:"Custom"}
                                    ];
                                    
                                    // Get available options from config
                                    let available = [];
                                    if (Body_config && Body_config[category]) {
                                        available = Body_config[category];
                                    }
                                    
                                    // Combine available with defaults to ensure we have at least 5 options
                                    let options = [...available];
                                    
                                    // If we have fewer than 5, fill with defaults (avoiding duplicates if possible)
                                    if(options.length < 5) {
                                        // Filter out defaults that might already be in available by name/id if needed, 
                                        // but here we just append from defaults list by index to fill gaps
                                        for(let i=0; i < 5 - available.length; i++) {
                                            if (defaults[i]) options.push(defaults[i]);
                                        }
                                    }
                                    
                                    // Force exactly 5 options
                                    return options.slice(0, 5).map((body, i) => (
                                        <div key={i} className={`body-type-option ${currBody?.id === body.id ? 'active' : ''}`} 
                                            style={{
                                                display: 'flex', 
                                                flexDirection: 'column', 
                                                alignItems: 'center', 
                                                gap: '3px',
                                                cursor: 'pointer',
                                                padding: '4px 8px',
                                                borderRadius: '4px',
                                                border: currBody?.id === body.id ? '1px solid #000' : '1px solid transparent',
                                                background: currBody?.id === body.id ? '#f5f5f5' : 'transparent',
                                                minWidth: '50px'
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if(setCurrBody) setCurrBody(body);
                                                setActiveTool(null);
                                            }}>
                                            <User size={18} strokeWidth={1.5} />
                                            <span style={{fontSize: '9px', fontWeight: 500}}>{body.name || `Type ${i+1}`}</span>
                                        </div>
                                    ));
                                })()}
                            </div>
                        )}
                        <div className="bottom-icon-container" onClick={(e) => { e.stopPropagation(); setActiveTool(activeTool === 'skin' ? null : 'skin'); /* Skin tone logic */ }}>
                            <div className={`bottom-icon-btn ${activeTool === 'skin' ? 'active' : ''}`}>
                                <User size={24} color={activeTool === 'skin' ? '#fff' : '#000'} />
                            </div>
                            <span className="bottom-icon-label">Skin Tone</span>
                        </div>
                    </div>

                    <div className="bottom-icon-container" onClick={(e) => { e.stopPropagation(); setActiveTool(activeTool === 'summary' ? null : 'summary'); /* Summary logic */ }}>
                        <div className={`bottom-icon-btn ${activeTool === 'summary' ? 'active' : ''}`}>
                            <FileText size={24} color={activeTool === 'summary' ? '#fff' : '#000'} />
                        </div>
                        <span className="bottom-icon-label">Summary</span>
                    </div>

                    <div className="bottom-icon-container" onClick={(e) => { e.stopPropagation(); setActiveTool(activeTool === 'share' ? null : 'share'); /* Share logic */ }}>
                        <div className={`bottom-icon-btn ${activeTool === 'share' ? 'active' : ''}`}>
                            <Share2 size={24} color={activeTool === 'share' ? '#fff' : '#000'} />
                        </div>
                        <span className="bottom-icon-label">Share</span>
                    </div>

                    <div className="bottom-icon-container" onClick={(e) => { e.stopPropagation(); setActiveTool(activeTool === 'favourite' ? null : 'favourite'); /* Favourite logic */ }}>
                        <div className={`bottom-icon-btn ${activeTool === 'favourite' ? 'active' : ''}`}>
                            <Heart size={24} color={activeTool === 'favourite' ? '#fff' : '#000'} />
                        </div>
                        <span className="bottom-icon-label">Favourite</span>
                    </div>

                    <div className="bottom-icon-container" onClick={(e) => { e.stopPropagation(); setActiveTool(activeTool === 'zoom' ? null : 'zoom'); /* Zoom logic */ }}>
                        <div className={`bottom-icon-btn ${activeTool === 'zoom' ? 'active' : ''}`}>
                            <ZoomIn size={24} color={activeTool === 'zoom' ? '#fff' : '#000'} />
                        </div>
                        <span className="bottom-icon-label">Zoom</span>
                    </div>
                </div>

                <div className="v-display"
                        onClick={()=>{
                            if(isMobile){
                                setMenuOpen(0)
                                setMenuOpen2(0)
                                setMenuOpenEmb(0)
                            }
                        }}
                >

                    <ViewImages 
                        category ={category}
                        sel = {sel}
                        single={single}
                        loading = {loading}
                        setLoading={setLoading}

                        imgState ={imgState}
                        setImgState = {setImgState}
                        
                        type = {0}
                        isMobile = {isMobile}

                        jodh = {jodh}

                        initial = {initial}

                        setCurrBody={setCurrBody}
                        currBody={currBody}
                        
                        setState1 = {setStates}

                        getStyleImg = {getStyleImg}
                    />
                    { category === "kurta" && (() => {
                        try {
                            const sec = sel?.second_images;
                            if (!sec) return null;
                            const sleeveSel = sel?.style?.Kurta?.F?.[8];
                            if (sleeveSel === "SN" && sec["SN_DEFAULT"]) {
                                return (
                                    <div style={{
                                        position: 'absolute',
                                        top: '10px',
                                        left: '10px',
                                        zIndex: 120,
                                        background: 'rgba(0,0,0,0.6)',
                                        color: '#fff',
                                        padding: '6px 10px',
                                        borderRadius: '6px',
                                        fontSize: '12px',
                                        letterSpacing: '0.3px'
                                    }}>
                                        No Cuff View
                                    </div>
                                );
                            }
                            // Removed Cuff Variant label logic as the menu is removed
                            return null;
                        } catch {
                            return null;
                        }
                    })()}
                    {/* // image scroll status section */}
                    

                        { nav !== 0 && !isMobile && <div className='image-scroll-sec hori_center'>
                            
                            <div className='img-scroll-dots'> 
                                <div className='round-left'>
                                </div>
                                <div className='i-s-d-m'>
                                    
                                    {   (sel && sel.types && (sel.types.includes("Coat") || sel.types.includes("Sadri")) && category === "kurta") &&
                                        <div className={imgState===-1 ? "i-s-dot1" : "i-s-dot"}
                                            onClick={()=>{
                                                if(imgState!==-1){
                                                    setLoading(true);
                                                }
                                                setImgState(-1);
                                                }}
                                        ></div>}
                                    {state && [...Array(state+1).keys()].map((val, key)=>{
                                        return(
                                            <div className={key === imgState ? "i-s-dot1" : "i-s-dot"}
                                                onClick={()=>{
                                                    if(imgState!== key){
                                                        setLoading(true);
                                                    }
                                                    setImgState(key);
                                                }}
                                            ></div>
                                        )
                                    })}
                                </div>
                                <div className='round-right'>
                                </div>
                            </div>
                        </div>}
                        <div {...handlers}></div>
                        
                        <div className="arrow-d">
            
                    <img src={isMobile ? nextArr1 : nextArr} className='v-arr-l'
                            type = "button"
                            style={ (imgState <=0 && !(category === "kurta" && (sel.types.includes("Coat") || sel.types.includes("Sadri") )))
                                    || (imgState <-1 && category === "kurta" && (sel.types.includes("Coat") || sel.types.includes("Sadri") ))
                                ? {display:"none"}:{}}

                            onClick={()=>{
                                if( ( !(category ==="kurta" && (sel.types.includes("Coat") || sel.types.includes("Sadri") ) ) && imgState > 0) 
                                    || ( (category ==="kurta" && (sel.types.includes("Coat") || sel.types.includes("Sadri") ) ) &&  imgState > -1 ) ){
                                    // console.log("Clicking")
                                    setLoading(true)
                                    setImgState(curr => curr - 1);
                                    setInitial(false)
                                }
                                // setImgState((curr)=>(    
                                //     curr > 0 ? curr - 1 : 0)
                                // )
                            }}
                        />
                    <img src={isMobile ? prevArr1 : prevArr} className='v-arr-r'
                            type = "button"
                            style={ imgState >= state ? {display:"none"}:{}}

                            onClick={()=>{
                                if(imgState < state-1){
                                    // console.log("clicking")
                                    setLoading(true)
                                }
                                
                                
                                setImgState((curr)=>(
                                curr < state ? curr + 1 : curr
                                ))
                                setInitial(false)
                    }}
                            
                        />
                </div>
      

                </div>
                
                {(!isMobile && sel && Object.hasOwn(sel, 'price')) && <div className="v-des">
                    <div className="v-des_section txt-font1">
                        
                        
                        <div className="title-font1"
                            style={{fontSize: '2.5rem', lineHeight: '1.2', marginBottom: '10px'}}
                        >Custom {category}</div>

                        {/* <Share_Like/> */}
                        
                        <div style={{
                           width: "100%", 
                           height: "auto", 
                           position: "relative",
                           marginBottom: "20px"
                        }}>
                            
                            {(sel && Object.hasOwn(sel, 'price')) && <div style={{fontSize: "1.2rem", fontWeight: "bold"}}>
                                {sel && sel.discount && sel.discount>0 ?
                                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                    <span style={{textDecoration: "line-through", color: "gray", fontSize: "1rem"}}>
                                        {sel.price.toLocaleString('en-IN', {
                                            maximumFractionDigits: 0,
                                            style: 'currency',
                                            currency: 'INR'
                                        })}
                                    </span>
                                    <span style={{color: "green"}}>
                                        {(sel.price-sel.discount).toLocaleString('en-IN', {
                                                maximumFractionDigits: 0,
                                                style: 'currency',
                                                currency: 'INR'
                                        })}
                                    </span>
                                </div> : 
                                <span style={{color: "green"}}>
                                    {sel.price.toLocaleString('en-IN', {
                                        maximumFractionDigits: 0,
                                        style: 'currency',
                                        currency: 'INR'
                                    })}
                                </span>}
                            </div>}

                            <div style={{"fontSize":"0.7rem", color: "gray"}} >
                                Estimated Delivery : { (new Date(  (new Date().setDate( (new Date()).getDate() +13 )) )).toDateString() }
                            </div>
                        
                        </div>
                        
                        {/* <a
                            className="a_tag"
                            type='button'
                            onClick={()=>{
                                setViewD(true)
                                getStyleDetails()
                            }}
                        >...More details</a> */}
                        <br/>

                        {/* {Object.keys(sel.style).map((val, k)=>{
                            return(
                                <><label>{sel.style[val]}</label><br/></>
                            )
                        })} */}
                        <div style={{"position":"relative", "width":"fit-content", "height":"fit-content", "display":"inline-block"}} >
                        <button className="Butt1 v-checkout"
                            style={{
                                backgroundColor: "black",
                                color: "white",
                                borderRadius: "5px",
                                padding: "12px 24px",
                                border: "none",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                fontFamily: "var(--font-body)",
                                textTransform: "uppercase",
                                fontSize: "0.75rem",
                                letterSpacing: "0.15em",
                                fontWeight: "500",
                                whiteSpace: "nowrap"
                            }}
                            onClick={()=>{
                                window.history.pushState( 'dummy', document.title, window.location.href )
                                
                                if(nav == 1){
                                    var stylesall_set = {}
                                    
                                    Object.keys(sel.style).forEach((e)=>{
                                        stylesall_set[e] = {
                                                display : {},
                                                style :{}   
                                            }
                                    })
                                    setStylesAll(stylesall_set)

                                    // setStylesAll({
                                    //     "Coat":{
                                    //         display : {},
                                    //         style :{}
                                    //     },
                                    //     "Vest":{
                                    //         display : {},
                                    //         style :{}
                                    //     },
                                    //     "Shirt":{
                                    //         display : {},
                                    //         style :{}
                                    //     },
                                    //     "Pant":{
                                    //         display : {},
                                    //         style :{}
                                    //     }
                                    // })
                                }
                                const [Data, allow] = DataCheck()
                                
                                if(allow){
                                    // sessionStorage.setItem("sel", JSON.stringify(Data))
                                    if((nav === 2 && category !== "suit") || (nav === 3 && category === "suit")){
                                        
                                        
                                            navigate(`/measurement/select/${encodeObj(Data)}`)
                                        
                                    }else{
                                        // console.log("Enabling ")
                                        
                                            navigate(`/custom/${category}/${Navs[nav+1]}/${process}/${encodeObj(Data)}`)
                                        
                                            setNav((prevNav)=>
                                                prevNav = prevNav+1
                                            )    
                                        
                                        
                                    }
                                    
                                }
                            }}
                        >
                            <span> 
                                {(nav === 2 && category !== "suit") ? "Get Measured" : "Lets Dressup" }
                            </span>
                            <span style={{fontSize: "1.2rem"}}>→</span>
                        </button>
                        {/* <div className='icons_zoom_war'>
                            <div >
                            <Tooltip TransitionComponent={Zoom} title="Visible Images are Renderd. It May be different from actual product. Open Fabric info to see real images of Fabric ">
                                
                                <img src={War} style={{"width":"25px", "opacity":"1"}}/>
                            </Tooltip>
                            </div>
                            <div >
                                <Tooltip TransitionComponent={Zoom} title="Click on the Image to Zoom">
                                    
                                    <img src={M} style={{"width":"25px", "opacity":"1"}}/>
                                </Tooltip>
                            </div>
                        </div> */}
                        {/* <div style={{"fontSize":"0.8rem"}} >
                            Estimated Delivery : { (new Date(  (new Date().setDate( (new Date()).getDate() +13 )) )).toDateString() }</div> */}
                        </div>
                    </div>
</div>}

                
                

{isMobile &&  (
    
    
        
    <div className="mobile-container">
        <div className="mobile-bottom-container">
            <div className='mobile_nav_bottom'>
                <div className='m-b-logos'>
                <div className={`m-b-logo-single ${isEmbEnabled(category) ? 'm-b-logo-single-emb' : '' }`}
                        onClick={()=>{
                            
                                // navigate(`/custom/${category}/${Navs[1]}/${process}/${encodeObj(sel)}`)
                                // setNav(1)
                            
                        }}
                    >

                        { mess && <div className='tut_arrow move'>
                            {/* <span>Start</span> */}
                            <img src={curl}/>
                        </div>}

                        <img  src = {F} style={{"height":"25px"}} className='hori_center'
                            onClick={() => {setMenuOpen2(!menuOpen2);

                                setMess(false)}
                            }
                        />
                        <b><label onClick={()=>{
                            
                                // navigate(`/custom/${category}/${Navs[1]}/${process}/${encodeObj(sel)}`)
                            
                                // setNav(1)
                            
                        setMenuOpen2(!menuOpen2);

                        setMess(false)
                            
                        }} >Fabric</label></b>
                        {nav === 0 && 
                        <div className='m-b-logos-line'></div> }
                    </div>
                    <div className={`m-b-logo-single ${isEmbEnabled(category) ? 'm-b-logo-single-emb' : '' }`}
                        onClick={()=>{
                               
                                // navigate(`/custom/${category}/${Navs[2]}/${process}/${encodeObj(sel)}`, {replace:true})
                            
                                // setNav(2)
                            
                            // setNav(1)
                        }}
                    >
                        <img  src = {S} style={{"height":"25px"}} className='hori_center'
                            onClick={() => {setMenuOpen(!menuOpen);


                            setMess(false);
                                }
                            }
                        />
                        <b><label onClick={()=>{
                            // navigate(`/custom/${category}/${Navs[2]}/${process}/${encodeObj(sel)}`)
                            
                            // setNav(2)
                            setMenuOpen(!menuOpen);


                            setMess(false);
                        }}>Style</label></b>
                        {nav === 2 && 
                        <div className='m-b-logos-line'></div> }
                    </div>
                    { isEmbEnabled(category) &&
                     <div className={`m-b-logo-single ${isEmbEnabled(category) ? 'm-b-logo-single-emb' : '' }`}
                        onClick={()=>{
                            setMenuOpenEmb(!menuOpenEmb);
                            setMess(false);
                            console.log("click working", !menuOpenEmb)
                        }}
                    >
                        <img  src = {emb_logo_mob} style={{"width":"25px"}} className='hori_center'/>
                        <b><label
                            onClick={()=>{
                                setMenuOpenEmb(!menuOpenEmb);
                                setMess(false)
                                console.log("click working", !menuOpenEmb)
                            }}
                        >Embroidery</label></b>
                        {nav === 3 && 
                        <div className='m-b-logos-line'></div> }
                    </div>
                    }
                    <div className={`m-b-logo-single ${isEmbEnabled(category) ? 'm-b-logo-single-emb' : '' }`}
                        onClick={()=>{
                            setViewD(true)
                            getStyleDetails();
                        }}
                    >
                        <img  src = {I} style={{"width":"25px"}} className='hori_center'/>
                        <b><label
                            onClick={()=>{
                                setViewD(true)
                                getStyleDetails();
                            }}
                        >info</label></b>
                    </div>
                </div>
            </div>
            <div className='money-custom'>
                <div className='custom-set-1'>
                    <b><div>Custom {category} #1</div></b>
                    
                    {(sel && Object.hasOwn(sel, 'price')) && <div>
                        {sel && sel.discount && sel.discount>0 ?
                        `${(sel.price-sel.discount).toLocaleString('en-IN', {
                                maximumFractionDigits: 2,
                                style: 'currency',
                                currency: 'INR'
                        })}` : 
                        `${sel.price.toLocaleString('en-IN', {
                            maximumFractionDigits: 2,
                            style: 'currency',
                            currency: 'INR'
                        })}`}
                        
                        <span 
                            style = { sel && sel.discount && sel.discount>0 ? {"color":"green", "marginLeft":"5px", "fontSize":"0.8"}:{"display":"none"}}
                        > { Math.round((sel.discount / sel.price)*100)}% off </span>
                    </div>}
                    <div style={{"fontSize":"0.8rem"}} >
                            Estimated Delivery : { (new Date(  (new Date().setDate( (new Date()).getDate() +13 )) )).toDateString() }</div>
                </div>

                <button className="Butt1last v-checkout"
                onClick={() => {
                    setMess(false);
                    const [Data, allow] = DataCheck();
                    if (allow) {

                        // sessionStorage.setItem("sel", JSON.stringify(Data));

                        if((nav === 2 && category !== "suit") || (nav === 3 && category === "suit")){

                                navigate(`/measurement/select/${encodeObj(Data)}`)
                                // setNav(2)
                            
                        }else{
                            setMenuOpen(true)
                            
                                navigate(`/custom/${category}/${Navs[nav+1]}/${process}/${encodeObj(Data)}`)
                            
                                setNav((prevNav)=>
                                    prevNav = prevNav+1
                                )
                        }
                    }
                }}
                >
                    {(nav === 2 && category !== "suit") ? "Get Measured" : "Lets Dressup" }
                </button>

                
            </div>
            
        </div>
    </div>
)}

            </div>

            {viewD && <>
            <div className='opac'></div>
            <div className='view_details both_center'>
                <img src={close} style={{"position":"absolute", "right":"5px", "top":"5px"}}
                    onClick={()=>{
                        setViewD(false)
                    }}
                />
                <div className='v-modal-top hori_center txt-font1'>
                    {sel && [...sel.types, ...["Cost Breakup"]].map((type_v)=>{
                        return(
                            <div className={ viewDet === type_v ?  'v-m-t-t' : 'v-m-t-t1'}
                                style={{"width":`${100/sel.types.length}%`}}
                                onClick={()=>{setCurrentDet(type_v);
                                    // getStyleDetails();
                                }}
                                type="button"
                            >{type_v}</div>
                        )
                    })}
                    
                    {/* <div className={ viewDet === 1 ?  'v-m-t-t' : 'v-m-t-t1'}
                        onClick={()=>{setCurrentDet(1) ; getStyleDetails(); }}
                        type="button"
                    >Style</div> */}
                </div>
                {viewDet != "Cost Breakup" && <div className='v-m-des txt-font1 hori_center'>
                        <div style={{"textAlign":"center", "marginBottom":"35px","fontSize":"1.5rem" ,"marginTop":"10px"}} ><b>Fabric Details</b></div>
                        <div style={{"width":"fit-content"}} className='hori_center'>
                            
                            <div className='v-m-d-f-comp'>

                                {/* <div><label className='both_center'><b>{viewDet}</b></label> </div> */}
                                
                                    
                                    <div className='v-m-d-f-img'><img src = {sel["fabric"][viewDet]["brandImg"]} style={{"width":"100%", "height":"100%", "objectFit":"cover"}} /></div>
                                
                                    <div 
                                        style={{"backgroundColor":"#14213D", "color":"white", "fontWeight":"bold", "padding":"0% 10px", "width":"fit-content"}}
                                    >
                                        <label className='verti_center'
                                            style={{"height":"fit-content", "margin":"0"}}
                                        >{sel["fabric"][viewDet]["fabric"]}</label>
                                    </div>
                                
                                
                            </div>
                            
                        </div>
                        <div className='styleDes-line hori_center'>  </div>
                        <div style={{"textAlign":"center", "marginTop":"10px", "fontSize":"1.5rem"}} ><b>Style Details</b></div><br/>
                        <div>
                            <div style={{"width":`${Math.min(styleDes[viewDet].slice(0, 4).length, 4)*25}%`, "display":"flex", "position":"relative", "justifyContent":"center"}}
                                className='hori_center'

                            >
                                { styleDes && styleDes[viewDet].slice(0, 4).map((sty)=>{
                                    return(
                                        <div className='single_s_des'
                                            style={{"width":`${80/styleDes[viewDet].slice(0, 4).length}%`}}
                                        >
                                            <img src={sty.img} className='hori_center' />
                                            <b><label>{sty.type}</label></b>
                                            <label>{sty.name}</label>
                                            
                                        </div>
                                    )
                                })
                                }
                            </div>
                            <div style={{"width":`${Math.min(styleDes[viewDet].slice(4, 8).length, 4)*25}%`, "display":"flex", "position":"relative"}}
                                className='hori_center'

                            >
                                { styleDes && styleDes[viewDet].slice(4, 8).map((sty)=>{
                                    return(
                                        <div className='single_s_des'
                                            style={{"width":`${100/styleDes[viewDet].slice(4, 8).length}%`}}
                                        >
                                            <img src={sty.img} className='hori_center' />
                                            <b><label>{sty.type}</label></b>
                                            <label>{sty.name}</label>
                                            
                                        </div>
                                    )
                                })
                                }
                            </div>
                            
                        </div>
                        <br/><br/>
                        
                        
                        
                        {/* : (<>
                            {styleDes ? (<>

                                    {Object.keys(styleDes).map((typs, k)=>(
                                        <div className='s-comp-wrap'>
                                        <div className='eachStyleDes'>
                                        <div className='s-des-left'> 
                                        <b><label className='both_center'
                                                style={{"height":"fit-content"}}
                                            >{typs} </label></b>
                                        </div>
                                        <div className='s-des-right'>
                                            {Object.keys(styleDes[typs]).map((values, k1)=>{
                                                return(
                                                    <> 
                                                    {styleDes[typs][values].map((val1, k2)=>{
                                                        return(<div>
                                                            {val1.includes(typs) ? val1.split(typs)[1].trim() : val1 } 
                                                        </div>)
                                                    })

                                                    } </>
                                                )        
                                            } )
                                            }
                                        </div>
                                        
                                        </div>
                                        <div className='styleDes-line hori_center'>  </div>
                                        </div>
                                    ))}

                            </>) : <>Please Select Styles</>}
                        </>)} */}
                </div>}
                {
                    viewDet === "Cost Breakup" && 
                    <div className='v-m-des txt-font1 hori_center'>
                        
                        <label>Total Items { sel.types.length }</label>
                        <table className='cost_break_up' style={{width:'100%', textAlign:"center"}}>
                            <tr>
                                <th>Item</th>
                                <th>Price</th>
                            </tr>
                            {
                                sel.types.map((vals)=>{
                                    return(
                                        <tr>
                                            <td>{vals}</td>
                                            <td>{
                                            parseInt(sel.fabric[vals].price).toLocaleString('en-IN', {
                                                maximumFractionDigits: 2,
                                                style: 'currency',
                                                currency: 'INR'
                                            })}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            <tr>
                                <td>Total</td>
                                <td> {sel.price.toLocaleString('en-IN', {
                                maximumFractionDigits: 2,
                                style: 'currency',
                                currency: 'INR'
                            })}  </td>
                            </tr>

                            <tr
                            style = { sel && sel.discount && sel.discount>0 ? {}:{"display":"none"}}
                            >
                                {/* ₹ {sel.price} */}
                                <td> <b>After Discount</b>  </td>
                                <td>
                                {(sel.price-sel.discount).toLocaleString('en-IN', {
                                    maximumFractionDigits: 2,
                                    style: 'currency',
                                    currency: 'INR'
                                })}
                                </td>
                                
                            </tr>

                            
                        </table>

                    </div>
                }
            </div>
            </>
            }
        </div>
    )
}
